import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<path d=\"M11.0001 23.1701V15.0001H3.08008L13.0001 0.830078V9.00008H20.9201L11.0001 23.1701ZM6.92008 13.0001H13.0001V16.8301L17.0801 11.0001H11.0001V7.17008L6.92008 13.0001Z\" fill={{this.fill}}></path>", {
  moduleName: "@dashboard/shared-ui/components/svgs/market/lightning-bolt.hbs"
});